module.exports = __webpack_public_path__ + "img/Bear26.16737d36.jpg";